import { Box, SxProps } from "@mui/material";

export enum HTMLDisplayType {
    div = "div",
    span = "span",
}

export interface UIHTMLDisplayProps {
    sx?: SxProps;
    html: string;
    displayType?: HTMLDisplayType;
}

export function UIHTMLDisplay(props: UIHTMLDisplayProps) {
    if (!props.displayType || props.displayType == HTMLDisplayType.div)
        return (
            <Box
                sx={props.sx}
                dangerouslySetInnerHTML={{ __html: props.html }}
            ></Box>
        );

    return (
        <Box
            sx={props.sx}
            component={"span"}
            dangerouslySetInnerHTML={{ __html: props.html }}
        ></Box>
    );
}
